<template>
  <div class="leftNav">
    <div class="userInfo">
      <img
        :src="userInfo.photoLocation?userInfo.photoLocation:'https://www.iczhiku.com/static/img/header.png'"
      />
      <p>
        {{userInfo.realName}}
        <br />
        <span v-if="userInfo.expertflag==1">老师</span>
        <span v-if="userInfo.expertflag==2">学生</span>
      </p>
    </div>
    <div class="navbar" v-if="userInfo.expertflag==2">
      <div class="active">
        <i class="el-icon-date"></i>
        课程表
      </div>
      <!-- <div>
        <i class="el-icon-edit-outline"></i>
        登录记录
      </div>
      <div>
        <i class="el-icon-bell"></i>
        通知消息
      </div>
      <div>
        <i class="el-icon-chat-dot-square"></i>
        提问及反馈
      </div> -->
    </div>
    <div class="navbar" v-if="userInfo.expertflag==1">
      <div class="active">
        <i class="el-icon-user"></i>
        学生管理
      </div>
      <!-- <div>
        <i class="el-icon-edit-outline"></i>
        新学生管理
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "navbar",
  props: ["userInfo"]
}
</script>

<style lang="less" scoped>
.leftNav {
  background: #1b1f33;
  height: 700px;
  width: 175px;
  color: #fff;
  float: left;
  .userInfo {
    height: 48px;
    padding: 34px 0;
    img {
      width: 48px;
      height: 48px;
      margin: 0 15px;
      border-radius: 4px;
      display: block;
      float: left;
      background: #f8f8f8;
    }
    p {
      float: left;
      font-size: 12px;
      line-height: 20px;
      padding-top: 4px;
      span {
        font-size: 14px;
      }
    }
  }
  .navbar {
    div {
      height: 62px;
      line-height: 62px;
      font-size: 14px;
      border-bottom: 1px solid #424766;
      &.active {
        background: #424766;
      }
      i {
        padding: 0 12px 0 30px;
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/navbar.vue